import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import { Container } from "react-grid-system";
import styled from "styled-components";
import Colors from "../../shared/colors";
import "./header.component.css";

// COMPONENTS
import MenuResponsive from "../menuresponsive/menuresponsive.component";
import Social from "../social/social.component";
import Dropdown from "../dropdown/dropdown.component";

// IMAGES
import ptLogo from "../../images/pt_logo.svg";
import enLogo from "../../images/en_logo.svg";
import ptLogoColor from "../../images/header/pt_logo_color.svg";
import enLogoColor from "../../images/header/en_logo_color.svg";

// ICONS
import FaBars from "react-icons/lib/fa/bars";

export default class Header extends Component {
  constructor() {
    super();
    this.state = {
      top: true,
      visible: false,
      logo: "",
      isOpen: false,
      setLink: false,
    };
    this.openMenu = this.openMenu.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.setLogo = this.setLogo.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    this.setLogo(this.props.i18n);
  }

  handleScroll() {
    if (window.scrollY > 120) {
      this.setState({
        top: false,
        isOpen: false,
      });
      this.setLogo(this.props.i18n);
    } else {
      this.setState({
        top: true,
      });
      this.setLogo(this.props.i18n);
    }
  }

  // TO DO
  setLogo(i18n) {
    if (i18n.language === "pt") {
      if (this.state.top) {
        this.setState({ logo: ptLogo });
      } else {
        this.setState({ logo: ptLogoColor });
      }
    } else {
      if (this.state.top) {
        this.setState({ logo: enLogo });
      } else {
        this.setState({ logo: enLogoColor });
      }
    }
  }

  openMenu() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  goto() {
    localStorage.setItem("selectedCategory", 0);
    localStorage.setItem("selectedMember", JSON.stringify([true]));
    localStorage.setItem("selectedCountry", JSON.stringify([true]));
    localStorage.setItem("selectedQualification", JSON.stringify([true]));
    localStorage.setItem("selectedArea", JSON.stringify([true]));
    localStorage.setItem("page", 1);
    localStorage.setItem("order", 0);
    localStorage.setItem("isFilter", false);
    localStorage.setItem("neworder", 3);

    // setTimeout(() => {
    //     document.querySelector('#start').scrollIntoView({behavior: 'smooth', block: "start"});
    // }, 100);

    this.setState({
      setLink: false,
    });
  }

  setActive = () => {
    this.setState({
      setLink: true,
    });
  };

  render() {
    const { t, i18n } = this.props;

    const lang = i18n.language;

    const { top, logo, isOpen } = this.state;

    return (
      <Master>
        <MenuResponsive
          isOpen={isOpen}
          close={this.openMenu}
          t={t}
          i18n={i18n}
        />
        <HeaderWrapper className={top ? "" : "onScrollBackground"}>
          <Container className="fix">
            <HeaderContent>
              <HeaderItem>
                <Link to="/" onClick={this.setActive}>
                  <Logo src={logo} className={top ? "" : "onScrollLogo"} />
                </Link>
              </HeaderItem>
              <HeaderItem className="menuItems">
                <MenuHeader className={top ? "" : "onScrollMenu"}>
                  <NavLink
                    exact
                    to={"/" + lang}
                    activeClassName="activeMenu"
                    className={this.state.setLink ? "activeMenu" : ""}
                    onClick={() => this.goto()}
                  >
                    {t("home")}
                  </NavLink>
                  <NavLink
                    to={"/" + lang + "/" + t("rede")}
                    activeClassName="activeMenu"
                    onClick={() => this.goto()}
                  >
                    {t("HeaderRede")}
                  </NavLink>
                  <NavLink
                    to={"/" + lang + "/" + t("restaurantes")}
                    activeClassName="activeMenu"
                    onClick={() => this.goto()}
                  >
                    {t("HeaderRestaurantes")}
                  </NavLink>
                  <NavLink
                    to={"/" + lang + "/" + t("produtos")}
                    activeClassName="activeMenu"
                    onClick={() => this.goto()}
                  >
                    {t("HeaderProdutos")}
                  </NavLink>
                  <NavLink
                    to={"/" + lang + "/" + t("receitas")}
                    activeClassName="activeMenu"
                    onClick={() => this.goto()}
                  >
                    {t("HeaderReceitas")}
                  </NavLink>
                  <NavLink
                    to={"/" + lang + "/" + t("workshops")}
                    activeClassName="activeMenu"
                    onClick={() => this.goto()}
                  >
                    {t("HeaderWorkshops")}
                  </NavLink>
                  <a
                    href="https://backoffice.tasteportugal.com/backend/site/login"
                    className={"login"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("Login")}
                  </a>
                </MenuHeader>
              </HeaderItem>
              <HeaderItem>
                <ActionsHeader>
                  <span className="menuItems">
                    <Social onSrollHeader={top} />
                  </span>
                  <Dropdown
                    onSrollHeader={top}
                    i18n={i18n}
                    setLogo={this.setLogo}
                  />
                  <BtnMenu
                    onClick={this.openMenu}
                    className={top ? "" : "btnMenu"}
                  >
                    <FaBars />
                  </BtnMenu>
                </ActionsHeader>
              </HeaderItem>
            </HeaderContent>
          </Container>
        </HeaderWrapper>
      </Master>
    );
  }
}

const Master = styled.div``;

const HeaderWrapper = styled.header`
  width: 100%;
  height: 100px;
  position: fixed;
  z-index: 999;
  transition: all 0.3s ease-in-out;
`;
const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;
const HeaderItem = styled.div`
  transition: all 0.3s ease-in-out;
  min-width: 150px;

  @media screen and (max-width: 450px) {
    min-width: auto;
  }
`;
const Logo = styled.img`
  width: 140px;
  margin-top: 10px;
  transition: all 0.3s ease-in-out;
`;
const MenuHeader = styled.div`
  a {
    color: #fff;
    padding: 15px;
    transition: all 0.2s ease-in-out;
    font-size: 14px;

    &.login {
      background-color: #11837b;
      color: #ffffff !important;
      border-radius: 3px;
      padding: 10px 15px;
      cursor: pointer;
      text-decoration: none;
      -webkit-transition: all 0.3s ease;
      transition: all 0.3s ease;
      font-family: "PT Sans";
      margin: 0 15px;

      &:hover {
        background: #149a90;
        color: #fff;
      }
    }
  }
  a:hover {
    color: ${Colors.primary};
  }
`;
const ActionsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
const BtnMenu = styled.div`
  color: ${Colors.white};
  font-size: 21px;
  cursor: pointer;
  margin-left: 15px;
  display: none;
  margin-top: -3px;
  @media screen and (max-width: 992px) {
    display: block;
  }
`;



// WEBPACK FOOTER //
// ./src/components/header/header.component.js